import { Decimal } from 'decimal.js-light'

// The backend rejects a bid whose amount isn't a multiple of the listing's
// bid precision ("bid amount should align with the bid precision") — not
// merely one with too many decimal places, which only agrees with that rule
// when the precision happens to be a power of ten (1, 0.1, 0.01, ...). A
// precision of 0 has no well-defined multiple, so it's treated as
// unrestricted rather than dividing by zero.
//
// Takes the raw input string, not a parsed float: Decimal avoids the float
// error `parseFloat(raw) % bidPrecision` would introduce for a precision
// like 0.01.
export const violatesBidPrecision = (
  raw: string,
  bidPrecision: number
): boolean => {
  if (bidPrecision <= 0) return false
  return !new Decimal(raw).mod(bidPrecision).isZero()
}
